import React from 'react';

/** Shared copy for breakout rooms 1–4 (same modal on enter each room). */
export const BREAKOUT_GUIDELINES_BODY = `Participation Guidelines
Open to all Intersect members
Use the “raise hand” / request to speak feature in the Virtual Hub

Keep contributions clear, concise, and relevant
Be mindful of time so others can participate


Code of Conduct

Maintain respectful and constructive dialogue
Avoid interruptions
No off-topic promotion or disruptive behavior


Moderation

Facilitated by the Intersect
Moderators will:
Manage speaking order
Keep discussion on track
Support smooth flow of conversation`;

export interface BreakoutGuidelinesModalProps {
  open?: boolean;
  onDismiss: () => void;
}

export function BreakoutGuidelinesModal({
  open = true,
  onDismiss,
}: BreakoutGuidelinesModalProps) {
  if (!open) return null;

  return (
    <div
      className="unity-modal-overlay absolute inset-0 flex items-center justify-center bg-black bg-opacity-60"
      onClick={onDismiss}
      style={{ zIndex: 10003 }}
    >
      <div
        className="relative mx-4 flex max-h-[min(85vh,720px)] max-w-2xl flex-col rounded-lg border-2 border-cyan-500 bg-gray-900 p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onDismiss}
          className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-red-600 text-lg font-bold text-white transition-colors hover:bg-red-700"
          aria-label="Close"
        >
          ×
        </button>

        <div className="min-h-0 flex-1 overflow-y-auto pr-1">
          <p className="whitespace-pre-line text-base leading-relaxed text-white">
            {BREAKOUT_GUIDELINES_BODY}
          </p>
        </div>

        <div className="mt-4 flex justify-end border-t border-gray-700 pt-4">
          <button
            type="button"
            onClick={onDismiss}
            className="rounded-lg bg-cyan-600 px-6 py-2 font-semibold text-white transition-colors hover:bg-cyan-700"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

// Formatting check: This modal should display a single, scrollable popup with the guidelines shown
// exactly as in the BREAKOUT_GUIDELINES_BODY string, with double newlines to separate sections.
// The "Close" (×) button and "OK" button both call onDismiss. Body uses whitespace-pre-line for formatting.
